import React from 'react';
import {
  FormGroup,
  Grid,
  PageContent,
  RemoteSession,
  useUserinfo,
} from '@mss/mss-component-library';
import { useTranslation } from 'react-i18next';
import dateFormat from 'dateformat';
import SessionStatus from '../../../../common/SessionStatus';
import RequestStatus from '../../../../common/RequestStatus';
import humanizeDuration from 'humanize-duration';

type OverviewProps = {
  session: RemoteSession;
};
export default function Overview({ session }: OverviewProps) {
  const [t] = useTranslation(['remoteAccess', 'common']);
  const [, , user] = useUserinfo();

  const diffTime =
    new Date(session.last_activity).getTime() -
    new Date(session.created_at).getTime();
  return (
    <>
      <PageContent title={t('Sessions')}>
        <Grid.Row>
          <Grid.Col width={4}>
            <FormGroup
              label={t('ID')}
              input={<span data-ta="attribute-sessionID">{session.id}</span>}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('User')}
              input={<>{session.user_object.name}</>}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Target Asset')}
              input={<>{session.asset_object.name}</>}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Session status')}
              input={
                <>
                  <SessionStatus status={session.status} />
                </>
              }
            />
          </Grid.Col>
          {session.remote_request_status && (
            <Grid.Col width={4}>
              <FormGroup
                label={t('Remote request status')}
                input={
                  <>
                    <RequestStatus status={session.remote_request_status} />
                  </>
                }
              />
            </Grid.Col>
          )}
          <Grid.Col width={4}>
            <FormGroup
              label={t('Started at')}
              input={
                <>
                  {dateFormat(session.created_at, 'mmmm dS, yyyy @ h:MM:ss TT')}
                </>
              }
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Last activity')}
              input={
                <>
                  {dateFormat(
                    session.last_activity,
                    'mmmm dS, yyyy @ h:MM:ss TT'
                  )}
                </>
              }
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Duration')}
              input={
                <>
                  {humanizeDuration(diffTime, {
                    round: true,
                    language: user?.language,
                  })}
                </>
              }
            />
          </Grid.Col>
          {session.revoke_date && (
            <Grid.Col width={4}>
              <FormGroup
                label={t('Revoked date')}
                input={
                  <>
                    {dateFormat(
                      session.revoke_date,
                      'mmmm dS, yyyy @ h:MM:ss TT'
                    )}
                  </>
                }
              />
            </Grid.Col>
          )}
        </Grid.Row>
      </PageContent>
    </>
  );
}
